import React, { Component } from 'react'
// import { storeData } from '../../storeData';
import './Footer.css';

export default class Footer extends Component {
  render() {
    const {storeData} = this.props
    return (
      <div className='Footer container-fluid'>
        <div className="row">
            <div className='Footer_section col-md-12 col-lg-6'>
                <div className='Footer_section_title'>Sobre {storeData.name}</div>
                <p>{storeData.about}</p>
            </div>

            <div className='Footer_section col-md-12 col-lg-6'>
                <div className='Footer_section_title'>Enlaces rapidos</div>
                <ul>
                    <li><a href="/terminos">Términos y condiciones</a></li>
                    <li><a href="/devoluciones">Política de reembolsos</a></li>
                    <li><a href="/envios">Política de envío</a></li>
                    <li><a href="/privacidad">Política de privacidad</a></li>
                    <li><a href="/nosotros">Sobre nosotros</a></li>
                    {/* <li><a href="/contacto">Contacto</a></li> */}
                </ul>
            </div>
        </div>
        <div className="row">
            <div className="Footer_copyright col-12">
                <p>Todos los derechos reservados {storeData.domain}</p>
            </div>
        </div>
      </div>
    )
  }
}
